import * as React from 'react';
import { Row, Col } from 'react-grid-system';
import styles from './ContactBlocks.styl';
import ColItem from '../ColItem/ColItem';
import GrayPhoneIcon from '../SVG/GrayPhoneIcon';
import GrayEnvelopeIcon from '../SVG/GrayEnvelopeIcon';
const col12 = 12;
const col6 = 6;
const ContactBlocks = ({ t }) => (React.createElement(Row, null,
    React.createElement(ColItem, { border: true, xs: col12, md: col6 },
        React.createElement(Row, null,
            React.createElement(Col, { xs: col12 },
                React.createElement("h2", { className: styles.header }, t('leftInfoBlockHeader')),
                React.createElement("p", { className: styles.text }, t('leftInfoBlockText'))))),
    React.createElement(ColItem, { border: true, xs: col12, md: col6 },
        React.createElement(Row, null,
            React.createElement(Col, { xs: col12 },
                React.createElement("h2", { className: styles.header }, t('rightInfoBlockHeader')),
                React.createElement("p", { className: styles.text }, t('rightInfoBlockText'))),
            React.createElement(Col, { xs: col12, sm: col6, md: col12, lg: col6, className: styles.colContact },
                React.createElement("a", { href: 'tel:+0341123456' },
                    React.createElement(Row, null,
                        React.createElement(Col, { className: styles.colIcon },
                            React.createElement(GrayPhoneIcon, { className: styles.icon })),
                        React.createElement(Col, null,
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: col12 },
                                    React.createElement("span", { className: styles.contactLabel }, t('telephoneText'))),
                                React.createElement(Col, { xs: col12 },
                                    React.createElement("span", { className: styles.contactText }, "0 800 - 40 30 181"))))))),
            React.createElement(Col, { xs: col12, sm: col6, md: col12, lg: col6, className: styles.colContact },
                React.createElement("a", { href: 'mailto:haendler@auto.de' },
                    React.createElement(Row, null,
                        React.createElement(Col, { className: styles.colIcon },
                            React.createElement(GrayEnvelopeIcon, { className: styles.icon })),
                        React.createElement(Col, null,
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: col12 },
                                    React.createElement("span", { className: styles.contactLabel }, t('emailText'))),
                                React.createElement(Col, { xs: col12 },
                                    React.createElement("span", { className: styles.contactText }, "haendler@auto.de")))))))))));
export default ContactBlocks;
